/**
 * True when a render-time error is a webpack lazy-chunk load failure —
 * the signature of a stale bundle after a fresh deploy. The tab was
 * opened against an older build, so the running bundle requests chunk
 * hashes the server no longer has; those requests 404 and come back as
 * `text/html`, which webpack surfaces as a `ChunkLoadError`.
 *
 * Matches webpack's `ChunkLoadError` name, the "Loading chunk N failed"
 * / "Loading CSS chunk N failed" messages, and the dynamic-import
 * failure variants — so the ErrorBoundary can hard-reload to pull the
 * new bundle instead of stranding the user on the error screen.
 */
export const isChunkLoadError = error => {
  if (!error) return false;
  if (error.name === 'ChunkLoadError') return true;
  const message = typeof error === 'string' ? error : error.message || '';
  return (
    /Loading (?:CSS )?chunk [\w-]+ failed/i.test(message) ||
    /ChunkLoadError/i.test(message) ||
    /failed to (?:import|fetch) dynamically imported module/i.test(message)
  );
};

export default isChunkLoadError;
